import React, { useState, useEffect, useContext } from 'react';
import { makeStyles, TextField, Button, Paper, Typography } from '@material-ui/core';
import MuiAlert from '@material-ui/lab/Alert';
import axios from 'axios';
import { UserContext } from '../App';

const useStyles = makeStyles((theme) => ({
  container: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  textArea: {
    width: '80%',
    margin: theme.spacing(2),
  },
  submitButton: {
    backgroundColor: '#01b5e2',
    color: 'white',
    '&:hover': {
      backgroundColor: '#0193b7',
    },
    padding: theme.spacing(1),
    margin: theme.spacing(1),
  },
  alert: {
    width: '80%',
    marginTop: theme.spacing(2),
  },
  chatContainer: {
    width: '80%',
    padding: theme.spacing(2),
  },
  userMessage: {
    textAlign: 'left',
    color: '#000',
    backgroundColor: '#f1f1f1',
    padding: theme.spacing(1),
    margin: theme.spacing(1),
    borderRadius: 8,
  },
  botMessage: {
    textAlign: 'right',
    color: '#fff',
    backgroundColor: '#2196f3',
    padding: theme.spacing(1),
    margin: theme.spacing(1),
    borderRadius: 8,
  },
}));

const CreateEmbeddings = () => {
  const classes = useStyles();
  const [textAreaValue, setTextAreaValue] = useState('');
  const [chatInput, setChatInput] = useState('');
  const [question, setQuestion] = useState('');
  const [showSuccessAlert, setShowSuccessAlert] = useState(false);
  const [chatHistory, setChatHistory] = useState([]);
  const userId = useContext(UserContext);


  const handleSubmit = async () => {

    try {
      const response = await axios.post('https://gptapi.acecura.com/api/embeddings',
        //const response = await axios.post('http://acegpt.eu-west-2.elasticbeanstalk.com/api/embeddings',
        {
          content: textAreaValue,
          userid: userId,
          contenttype: "manual"

        },
        {
          headers: { 'x-api-key': '56a613f1-9d5a-4cc8-8a69-ad06e603397d' }
        });

      if (response.status === 200) {
        //console.log('Embedding created successfully');
        setTextAreaValue('');
        setShowSuccessAlert(true);
      }
    } catch (error) {
      console.error('Error:', error);
    }
  };

  const handleKeyDown = (e) => {
    if (e.key === 'Enter' && !e.shiftKey) {
      e.preventDefault();
      handleChatSubmit();
      setChatInput('');
    }
  };

  const handleChatSubmit = async () => {
    // Create a new chat history array with the user's message and 'Typing...'
    const newChatHistory = [...chatHistory, { type: 'user', content: chatInput }, { type: 'bot', content: 'Typing...' }];
  
    // Update the state
    setChatHistory(newChatHistory);
  
  
    // Get the last 6 messages, excluding the 'Typing...' message
    const lastSixMessages = newChatHistory.slice(-7, -1).map(msg => {
      return `${msg.type === 'user' ? 'user' : 'response'}: ${typeof msg.content === 'object' ? msg.content.text : msg.content}`;
    }).join('\n');
  
    console.log(lastSixMessages);

    try {
      const response = await axios.post('https://gptapi.acecura.com/api/ask-ace-gpt', {
        query: lastSixMessages,
      }, {
        headers: { 'x-api-key': '56a613f1-9d5a-4cc8-8a69-ad06e603397d' }
      });
  
      if (response.status === 200) {
        setChatHistory(prevChatHistory => {
          const updatedChatHistory = [...prevChatHistory];
          updatedChatHistory.pop(); // Remove the 'Typing...' message
          updatedChatHistory.push({ type: 'bot', content: response.data });
          return updatedChatHistory;
        });

        setChatInput('');
      }
    } catch (error) {
      console.error('Error:', error);
    }
  };
  
  

  return (
    <div className={classes.container}>
      <TextField
        className={classes.textArea}
        id="outlined-multiline-static"
        label="Text to vectorize"
        multiline
        minRows={10}
        variant="outlined"
        value={textAreaValue}
        onChange={(e) => setTextAreaValue(e.target.value)}
      />
      <Button className={classes.submitButton} onClick={handleSubmit}>
        Submit
      </Button>
      {showSuccessAlert && (
        <MuiAlert
          className={classes.alert}
          severity="success"
          onClose={() => setShowSuccessAlert(false)}
        >
          Embedding created successfully
        </MuiAlert>
      )}
      <Paper className={classes.chatContainer}>
        <Typography variant="h6">Chat with Ace GPT</Typography>
        {chatHistory.map((msg, index) => (
          <div key={index} className={msg.type === 'user' ? classes.userMessage : classes.botMessage}>
            {typeof msg.content === 'object' ? msg.content.text : msg.content}
          </div>
        ))}

        <TextField
          id="outlined-basic"
          label="Type your message"
          variant="outlined"
          fullWidth
          value={chatInput}
          onChange={(e) => setChatInput(e.target.value)}
          onKeyDown={handleKeyDown}
        />
        <Button className={classes.submitButton} onClick={handleChatSubmit}>
          Send
        </Button>
      </Paper>
    </div>
  );
};

export default CreateEmbeddings;
